import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumLocationBondedStatus implements BaseEnumType {
  private static allValues: EnumLocationBondedStatus[] = []; // make sure this is top-most
  
  public static unknown = new EnumLocationBondedStatus(0, "Unknown", "enum_location_bonded_status_unknown");
  public static breweryNonBonded = new EnumLocationBondedStatus(1, "BreweryNonBonded", "enum_location_bonded_status_brewery_non_bonded");
  public static breweryBonded = new EnumLocationBondedStatus(2, "BreweryBonded", "enum_location_bonded_status_brewery_bonded");
  public static externalNonBonded = new EnumLocationBondedStatus(3, "ExternalNonBonded", "enum_location_bonded_status_external_non_bonded");
  public static externalBonded = new EnumLocationBondedStatus(4, "ExternalBonded", "enum_location_bonded_status_external_bonded");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumLocationBondedStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isUnknown() { return this === EnumLocationBondedStatus.unknown; }
  public isBreweryNonBonded() { return this === EnumLocationBondedStatus.breweryNonBonded; }
  public isBreweryBonded() { return this === EnumLocationBondedStatus.breweryBonded; }
  public isExternalNonBonded() { return this === EnumLocationBondedStatus.externalNonBonded; }
  public isExternalBonded() { return this === EnumLocationBondedStatus.externalBonded; }

  public static getValues(): readonly EnumLocationBondedStatus[] {
    return EnumLocationBondedStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumLocationBondedStatus[] {
    return EnumLocationBondedStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumLocationBondedStatus {
    const found = EnumLocationBondedStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumLocationBondedStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumLocationBondedStatus): EnumLocationBondedStatus {
    const found = name ? EnumLocationBondedStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumLocationBondedStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumLocationBondedStatus>): boolean {
    return this.key === other?.key;
  }
}